/**
 * Helpers de descarga de exports del report (Excel + 2 PDFs).
 * Sin React: build de params + trigger de blob como funciones puras.
 */

// Dispara la descarga de un Blob como un archivo con el nombre dado.
// El URL temporal se libera tras el click — limpiamos siempre, aunque
// la descarga falle.
export const triggerBlobDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

// Construye el payload que esperan los endpoints de export. Encapsula
// las reglas de "no envíes params vacíos" (depositsValue, familyQuery
// y tz vacíos se omiten porque objectToParams serializaría null como
// la string "null").
export const buildExportParams = ({
  season,
  year,
  validFilters,
  depositsValue,
  depositRolesValue,
  depositGroupsValue,
  familyQuery,
  currency,
  timezone,
}) => ({
  season,
  year,
  ...validFilters,
  currency: currency.symbol,
  exchange: currency.exchange,
  ...(depositsValue ? { deposits: depositsValue } : {}),
  ...(depositRolesValue ? { depositRoles: depositRolesValue } : {}),
  ...(depositGroupsValue ? { depositGroups: depositGroupsValue } : {}),
  ...(familyQuery ? { family: familyQuery } : {}),
  ...(timezone ? { tz: timezone } : {}),
});

// Nombre de fichero estándar: `eficacia_[slug_]<season>_<year>.<ext>`.
// `slug` distingue PDFs (resumen / series) del Excel y del PDF
// "principal" (sin slug, no usado todavía).
export const exportFileName = ({ slug = '', season, year, ext }) => {
  const seasonLower = String(season).toLowerCase();
  const prefix = slug ? `${slug}_` : '';
  return `eficacia_${prefix}${seasonLower}_${year}.${ext}`;
};
